import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  FETCH_CART_ITEMS,
  UPDATE_CART_ITEM,
  REMOVE_CART_ITEM,
  FETCH_CART_COUNT,
  MOVE_TO_WISHLIST,
} from 'store/actionTypes';
import {
  getAllCartItems,
  updateCartItem,
  deleteCartItem,
  getCartCount,
  moveToWishlist,
} from 'services';

import {
  fetchCartItems,
  fetchCartItemsSuccess,
  fetchCartItemsError,
  updateCartItemSuccess,
  updateCartItemError,
  removeCartItemSuccess,
  removeCartItemError,
  fetchCartCountSuccess,
  fetchCartCountError,
  fetchCartCount,
  moveToWishlistSuccess,
  moveToWishlistError,
} from 'store/actions';

function* getCartItems() {
  try {
    const response = yield call(getAllCartItems);
    if (!response.message) {
      yield put(fetchCartItemsSuccess(response.data));
    } else {
      yield put(fetchCartItemsError(response.message));
    }
  } catch (error) {
    yield put(fetchCartItemsError(error));
  }
}

export function* watchFetchCartItems() {
  yield takeLatest(FETCH_CART_ITEMS, getCartItems);
}

function* updateCart({ payload }) {
  try {
    const response = yield call(updateCartItem, payload);
    if (!response.message) {
      yield put(updateCartItemSuccess(response.data));
      yield put(fetchCartItems());
      yield put(fetchCartCount());
    } else {
      yield put(updateCartItemError(response.message));
    }
  } catch (error) {
    yield put(updateCartItemError(error));
  }
}

export function* watchUpdateCartItem() {
  yield takeLatest(UPDATE_CART_ITEM, updateCart);
}

function* removeCartItem({ payload }) {
  try {
    const response = yield call(deleteCartItem, payload);
    if (!response.message) {
      yield put(removeCartItemSuccess(response.data));
      yield put(fetchCartItems());
      yield put(fetchCartCount());
    } else {
      yield put(removeCartItemError(response.message));
    }
  } catch (error) {
    yield put(removeCartItemError(error));
  }
}

export function* watchRemoveCartItem() {
  yield takeLatest(REMOVE_CART_ITEM, removeCartItem);
}

function* getCartCounts() {
  try {
    const response = yield call(getCartCount);
    if (!response.message) {
      yield put(fetchCartCountSuccess(response.data));
    } else {
      yield put(fetchCartCountError(response.message));
    }
  } catch (error) {
    yield put(fetchCartCountError(error));
  }
}

export function* watchFetchCartCount() {
  yield takeLatest(FETCH_CART_COUNT, getCartCounts);
}

function* moveToWishlistItem({ payload }) {
  try {
    const response = yield call(moveToWishlist, payload);
    if (!response.message) {
      yield put(moveToWishlistSuccess(response.data));
      yield put(fetchCartItems());
      yield put(fetchCartCount());
    } else {
      yield put(moveToWishlistError(response.message));
    }
  } catch (error) {
    yield put(moveToWishlistError(error));
  }
}

export function* watchMoveToWishlistItem() {
  yield takeLatest(MOVE_TO_WISHLIST, moveToWishlistItem);
}
export default function* rootSaga() {
  yield all([
    fork(watchFetchCartItems),
    fork(watchUpdateCartItem),
    fork(watchRemoveCartItem),
    fork(watchFetchCartCount),
    fork(watchMoveToWishlistItem),
  ]);
}
